<template>
  <div class="right-box">
      <div class="item">
        <img src="../assets/image/footer/h1.png" alt="" />
      </div>
    <div class="item">
      <img src="../assets/image/footer/h2.png" alt="" />
    </div>
  </div>
</template>
<script >
export default {
  name: "Helper",
  data() {
    return {

    }
  },

}
</script>
<style scoped lang="less">
  .right-box{
    position: fixed;
    right: 10px;
    top: 40%;
  }
  .right-box .item{
    margin-bottom: 20px;
  }
  .right-box img{
    display: block;
  }
</style>
